<template>
  <div class="singleMarketplaceAboutContainer w-100">
    <MarketingRow
      :id="singleMarketplaceAboutContent.top.id"
      :backgroundColor="singleMarketplaceAboutContent.top.backgroundColor"
      :body="singleMarketplaceAboutContent.top.body"
      :noAssetBackground="singleMarketplaceAboutContent.top.noAssetBackground"
      :textSide="singleMarketplaceAboutContent.top.textSide"
      :title="singleMarketplaceAboutContent.top.title"
      :titleType="singleMarketplaceAboutContent.top.titleType"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="singleMarketplaceAboutContent.top.title.join(' ')"
          :class="{ overflowImage: singleMarketplaceAboutContent.top.overflowImage, 'contain': singleMarketplaceAboutContent.top.containImage }"
          :src="!isMobile ? singleMarketplaceAboutContent.top.imageUrlDesktop : singleMarketplaceAboutContent.top.imageUrlMobile"
        />
      </template>
    </MarketingRow>
    <StatsRow title="Current Marketplace Stats" />
    <MarketingRow
      v-for="(
        {
          backgroundColor,
          body,
          bodyIsHTML,
          containImage,
          darkButtonEmit,
          darkButtonLink,
          darkButtonText,
          defaultButtonEmit,
          defaultButtonLink,
          defaultButtonText,
          hasBorderTop,
          id,
          textSide,
          title,
          titleType,
          noAssetBackground,
          overflowImage,
          primaryButtonLink,
          primaryButtonText,
          imageUrlDesktop,
          imageUrlMobile
        }, index
      ) in singleMarketplaceAboutContent.main"
      :id="id"
      :key="`main-${index}`"
      :backgroundColor="backgroundColor"
      :body="body"
      :bodyIsHTML="bodyIsHTML"
      :darkButtonEmit="darkButtonEmit"
      :darkButtonLink="darkButtonLink"
      :darkButtonText="darkButtonText"
      :defaultButtonEmit="defaultButtonEmit"
      :defaultButtonLink="defaultButtonLink"
      :defaultButtonText="defaultButtonText"
      :hasBorderTop="hasBorderTop"
      :noAssetBackground="noAssetBackground"
      :primaryButtonLink="primaryButtonLink"
      :primaryButtonText="primaryButtonText"
      :textSide="textSide"
      :title="title"
      :titleType="titleType"
      @defaultClicked="onDefaultClicked"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="title.join(' ')"
          :class="{ overflowImage: overflowImage, 'contain': containImage }"
          :src="!isMobile ? imageUrlDesktop : imageUrlMobile"
        />
      </template>
    </MarketingRow>

    <!-- Weekly Modal -->
    <ModalSlider :show="showWeeklyModal" @close="showWeeklyModal = false">
      <WeeklyAbout />
    </ModalSlider>

    <!-- Monthly Modal -->
    <ModalSlider :show="showMonthlyModal" @close="showMonthlyModal = false">
      <ExtendedAbout />
    </ModalSlider>

    <!-- Fixed Modal -->
    <ModalSlider :show="showFixedModal" @close="showFixedModal = false">
      <FixedPriceAbout />
    </ModalSlider>
  </div>
</template>

<script>
import { BImgLazy } from 'bootstrap-vue';
import ExtendedAbout from './ExtendedAbout.vue';
import WeeklyAbout from './WeeklyAbout.vue';
import FixedPriceAbout from './FixedPriceAbout.vue';
import StatsRow from '../../homepage/components/StatsRow.vue';
import MarketingRow from '../../homepage/components/MarketingRow.vue';
import ModalSlider from './ModalSlider.vue';
import { singleMarketplaceAboutContent } from '../constants/singleMarketplaceConstants';
import { baseIsMobile } from '../../marketplaces/mixins';

export default {
  name: 'SingleMarketplaceAbout',
  components: {
    BImgLazy,
    ExtendedAbout,
    FixedPriceAbout,
    MarketingRow,
    ModalSlider,
    StatsRow,
    WeeklyAbout
  },
  mixins: [baseIsMobile],
  data() {
    return {
      singleMarketplaceAboutContent,
      showWeeklyModal: false,
      showMonthlyModal: false,
      showFixedModal: false,
    };
  },
  methods: {
    onDefaultClicked(modalType) {
      switch (modalType) {
        case 'weekly':
          this.showWeeklyModal = true;
          break;
        case 'monthly':
          this.showMonthlyModal = true;
          break;
        case 'fixed':
          this.showFixedModal = true;
          break;
      }
    }
  }
};
</script>
